import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Layer_1" clip-path="url(#clip0_7322_265874)">
<path id="Vector (Stroke)" fill-rule="evenodd" clip-rule="evenodd" d="M6.40343 4.67367C3.80446 5.55024 2.3784 8.4226 3.25341 11.0169C4.12877 13.6123 6.99874 15.0331 9.59665 14.1569C12.192 13.2816 13.6129 10.4116 12.7367 7.81368L15.5811 6.85431C16.9863 11.0206 14.7249 15.5953 10.556 17.0014C6.38971 18.4066 1.81503 16.1451 0.408962 11.9763C-0.997458 7.80637 1.2788 3.23407 5.44406 1.82922L6.40343 4.67367Z" />
<path id="Vector" d="M9.66585 0.969959L7.94477 4.26202L6.28373 7.60411L4.28248 4.0819L2.2312 0.589722L5.95353 0.819866L9.66585 0.969959Z" />
<path id="Vector_2" d="M12.5379 5.11251C13.6286 5.11251 14.5091 4.23196 14.5091 3.14128C14.5091 2.05059 13.6286 1.17004 12.5379 1.17004C11.4472 1.17004 10.5667 2.05059 10.5667 3.14128C10.5667 4.23196 11.4472 5.11251 12.5379 5.11251Z" />
</g>
<defs>
<clipPath id="clip0_7322_265874">
<rect width="16" height="16.8205" fill="white" transform="translate(0 0.589722)"/>
</clipPath>
</defs>
</svg>
`;

export const EonSubscription = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
